export function getParticipantName(participants, defaultIndex, venueRole) {
    let participant = participants.find((participant) => participant.venueRole === venueRole);
    return participant
        ? participant.name
        : participants[defaultIndex].name;
}
export function generateParticipantMapping(events) {
    const idsNames = {};
    events.forEach(event => event.participants.forEach(participant => idsNames[participant.id] = participant.name));
    return idsNames;
}
//# sourceMappingURL=GetParticipantNameHelper.js.map